<!-- Guided-search steps: header, no footer (the step's action bar sits at the bottom) -->
<template>
  <div class="flow">
    <AppHeader />
    <main id="main" class="flow__main">
      <slot />
    </main>
  </div>
</template>

<style scoped>
.flow {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--gray-100);
}

.flow__main {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
